module.exports = __webpack_public_path__ + "img/studentAvatarGirl.a21bc95f.png";